import { z } from 'zod'

/** Generic non-empty string identifier (nanoid-shaped; format isn't enforced at the schema level). */
export const idSchema = z.string().min(1)
export const MutationIdSchema = z.uuid()

/** Milliseconds since epoch. All timestamps are stored as numbers at rest, never ISO strings or Date objects. */
export const msTimestampSchema = z.number().int().nonnegative()

/**
 * Campaign lifecycle phase computed by @tiktok/campaign (cold_start -> warm -> mature).
 * Not persisted directly on any row today, but shared across schemas/prompts that reference it
 * so PR 5 doesn't have to redefine it.
 */
export const PhaseEnum = z.enum(['cold_start', 'warm', 'mature'])
export type Phase = z.infer<typeof PhaseEnum>

export const CampaignKindEnum = z.enum(['creator', 'music', 'product', 'brand'])
export type CampaignKind = z.infer<typeof CampaignKindEnum>

/** TikTok content posting API privacy levels. Kept as a free-ish string (not enforced) on rows that predate this
 * enum's introduction — see comments on individual schemas. */
export const PrivacyLevelEnum = z.enum([
  'PUBLIC_TO_EVERYONE',
  'MUTUAL_FOLLOW_FRIENDS',
  'FOLLOWER_OF_CREATOR',
  'SELF_ONLY'
])
export type PrivacyLevel = z.infer<typeof PrivacyLevelEnum>
